import React from 'react';
import StackedContent from '../StackedContent/StackedContent';
import Card from '../Card/Card';
import { getTimeCardContentByGrade } from '@/utils/getContentByGradeUtils';

type Props = {
  grade: string;
};

const TimeCommitmentCard = ({ grade }: Props) => {
  const gradeBandContent = getTimeCardContentByGrade(grade);
  if (!gradeBandContent) return null;

  const { timeDesc, timeRangeHeader , media} = gradeBandContent;
  return (
    <StackedContent>
      <StackedContent.Col1 cols="10">
        <Card
          theme="primary-light"
          orientation="horizontal"
          eyebrow="Good to Know"
          header={timeRangeHeader}
          description={timeDesc}
          media={media}
          buttonText=""
          linkUrl=""
          linkTarget="_blank"
        />
      </StackedContent.Col1>
    </StackedContent>
  );
};

export default TimeCommitmentCard;
